<template>
  <div class="col-sm-12">
    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr class="header-lvl-1">
            <th rowspan="2" class="align-middle text-center sticky-col-1"
              >No</th
            >
            <th rowspan="2" class="align-middle text-center sticky-col-2"
              >Tanggal</th
            >
            <th rowspan="2" class="align-middle text-center sticky-col-uraian"
              >Uraian</th
            >
            <th colspan="4" class="text-center">Jumlah (Rp)</th>
            <th colspan="3" class="text-center">Pembayaran</th>
            <th rowspan="2" class="align-middle text-center">Kategori</th>
            <th rowspan="2" class="align-middle text-center">KET</th>
            <th rowspan="2" class="align-middle text-center">Draft</th>
            <th rowspan="2" class="align-middle text-center"
              >Approval Manager</th
            >
            <th rowspan="2" class="align-middle text-center"
              >Approval Bendahara</th
            >
            <th rowspan="2" class="align-middle text-center">Approval Ketua</th>
            <th rowspan="2" class="align-middle text-center">Dokumen Panjar</th>
            <!-- <th rowspan="2" class="align-middle text-center">Status Panjar</th> -->
            <th rowspan="2" class="align-middle text-center">Bukti Transfer</th>
            <th rowspan="2" class="align-middle text-center sticky-col-last"
              >Aksi</th
            >
          </tr>
          <tr class="header-lvl-2">
            <th class="text-center">Nilai DPP</th>
            <th class="text-center">PPN (%)</th>
            <th class="text-center">Biaya Lain</th>
            <th class="text-center">Nilai Total</th>
            <th class="text-center">Total Pembayaran</th>
            <th class="text-center">Selisih</th>
            <th class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="item.id">
            <td class="sticky-col-1 text-center">{{ index + 1 }}</td>
            <td class="sticky-col-2">{{ dateFormat(item.tanggal_panjar) }}</td>
            <td class="sticky-col-uraian"
              >Pjr {{ item.proyek ? item.proyek.kode_proyek : '' }}
              {{ item.uraian }} ({{ item.batch }})</td
            >
            <td class="text-right">{{ formatRupiah(item.nilai_dpp) }}</td>
            <td class="text-center">{{ item.ppn }}%</td>
            <td class="text-right">{{
              formatRupiah(hitungBiayaLain(item.biaya_lains))
            }}</td>
            <td class="text-right font-weight-bold">{{
              formatRupiah(hitungTotalItem(item))
            }}</td>
            <td class="text-right text-info font-weight-bold">{{
              formatRupiah(sumPembayaran(item.dokumens))
            }}</td>
            <td class="text-right" :class="getSelisihClass(item)">{{
              formatRupiah(hitungTotalItem(item) - sumPembayaran(item.dokumens))
            }}</td>
            <td class="text-center"
              ><span :class="getStatusClass(item)">{{
                getStatus(item)
              }}</span></td
            >
            <td class="text-center">{{ item.kategori || '-' }}</td>
            <td>{{ item.keterangan }}</td>
            <td class="text-center">
              <template
                v-if="
                  item.status_pengajuan_panjar === 'DRAFT' &&
                    canApprove
                "
              >
                <div
                  class="d-flex gap-5 align-items-center justify-content-center"
                >
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-danger"
                    @click="$emit('approval', 'ADMIN', 'DITOLAK', item.id)"
                  >
                    <i class="uil uil-times"></i>
                  </button>
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-primary"
                    @click="$emit('approval', 'ADMIN', 'DITERIMA', item.id)"
                  >
                    <i class="uil uil-check"></i>
                  </button>
                </div>
              </template>
              <template v-if="item.status_sekretaris !== null">
                {{ item.status_sekretaris }}
              </template>
            </td>
            <td class="text-center">
              <template
                v-if="
                  item.status_sekretaris === null &&
                    item.status_pengajuan_panjar === 'DITERIMA' &&
                    canApprove
                "
              >
                <div
                  class="d-flex gap-5 align-items-center justify-content-center"
                >
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-danger"
                    @click="$emit('approval', 'SEKRETARIS', 'DITOLAK', item.id)"
                  >
                    <i class="uil uil-times"></i>
                  </button>
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-primary"
                    @click="
                      $emit('approval', 'SEKRETARIS', 'DITERIMA', item.id)
                    "
                  >
                    <i class="uil uil-check"></i>
                  </button>
                </div>
              </template>
              <template v-if="item.status_sekretaris !== null">
                {{ item.status_sekretaris }}
              </template>
            </td>
            <td class="text-center">
              <template
                v-if="
                  item.status_pengajuan_panjar === 'DITERIMA' &&
                    item.status_sekretaris === 'DITERIMA' &&
                    item.status_bendahara === null &&
                    canApprove
                "
              >
                <div
                  class="d-flex gap-5 align-items-center justify-content-center"
                >
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-danger"
                    @click="$emit('approval', 'BENDAHARA', 'DITOLAK', item.id)"
                  >
                    <i class="uil uil-times"></i>
                  </button>
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-primary"
                    @click="$emit('approval', 'BENDAHARA', 'DITERIMA', item.id)"
                  >
                    <i class="uil uil-check"></i>
                  </button>
                </div>
              </template>
              <template v-if="item.status_bendahara !== null">
                {{ item.status_bendahara }}
              </template>
            </td>
            <td class="text-center">
              <template
                v-if="
                  item.status_pengajuan_panjar === 'DITERIMA' &&
                    item.status_sekretaris === 'DITERIMA' &&
                    item.status_bendahara === 'DITERIMA' &&
                    item.status_ketua === null &&
                    canApprove
                "
              >
                <div
                  class="d-flex gap-5 align-items-center justify-content-center"
                >
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-danger"
                    @click="$emit('approval', 'KETUA', 'DITOLAK', item.id)"
                  >
                    <i class="uil uil-times"></i>
                  </button>
                  <button
                    v-if="canApprove"
                    class="btn btn-sm btn-primary"
                    @click="$emit('approval', 'KETUA', 'DITERIMA', item.id)"
                  >
                    <i class="uil uil-check"></i>
                  </button>
                </div>
              </template>
              <template v-if="item.status_ketua !== null">
                {{ item.status_ketua }}
              </template>
            </td>
            <td class="text-center"
              ><button
                class="btn btn-sm btn-link"
                @click="$emit('download', item.id)"
                >Download</button
              ></td
            >
            <!-- <td class="text-center">{{ item.status_panjar }}</td> -->
            <td class="text-center">
              <div
                class="d-flex gap-5 align-items-center justify-content-center"
              >
                <button
                  v-if="item.status_panjar"
                  class="btn btn-sm btn-primary"
                  @click="$emit('list', item.id)"
                  ><i class="uil uil-bars"></i
                ></button>
                <button
                  v-if="canApprove && (item.status_panjar !== null)"
                  class="btn btn-sm btn-outline-primary"
                  @click="$emit('upload', item.id)"
                >
                  <i class="uil uil-upload"></i>
                </button>
              </div>
            </td>
            <td class="sticky-col-last text-center">
              <div
                class="d-flex gap-5 align-items-center justify-content-center"
              >
                <button
                  class="btn btn-sm btn-outline-primary"
                  @click="$emit('preview', item.id)"
                  ><i class="uil uil-search"></i
                ></button>
                <button
                  v-if="canEdit"
                  class="btn btn-sm btn-outline-info"
                  @click="$emit('edit', item.id)"
                  ><i class="uil uil-edit"></i
                ></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { canManage } from '@utils/permissions'
import moment from 'moment'

export default {
  name: 'PanjarTable',
  props: {
    items: { type: Array, required: true, default: () => [] },
    user: { type: Object, default: () => ({}) },
    canEdit: { type: Boolean, default: false },
  },
  computed: {
    canApprove() {
      return canManage(this.user, 'transaksi.proyek.data_panjar')
    },
  },
  methods: {
    dateFormat(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    formatRupiah(value) {
      if (!value) return '0'
      return Number(value)
        .toFixed(0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    sumPembayaran(pembayaran) {
      if (!Array.isArray(pembayaran)) return 0
      return pembayaran.reduce(
        (total, item) => total + Number(item.nominal || 0),
        0
      )
    },
    hitungBiayaLain(biayaLains) {
      if (!Array.isArray(biayaLains)) return 0
      return biayaLains.reduce(
        (total, item) => total + Number(item.biaya || 0),
        0
      )
    },
    hitungTotalItem(item) {
      if (!item) return 0

      const dpp = Number(item.nilai_dpp || 0)
      const ppn = (dpp * Number(item.ppn || 0)) / 100
      const biayaLain = this.hitungBiayaLain(item.biaya_lains || [])

      return this.normalizeNominal(dpp + ppn + biayaLain)
    },
    getSelisihClass(item) {
      const selisih =
        this.hitungTotalItem(item) - this.sumPembayaran(item.dokumens)
      return selisih === 0 ? 'text-success' : 'text-danger font-weight-bold'
    },
    getStatus(item) {
      const total = this.hitungTotalItem(item)
      const rekon = this.sumPembayaran(item.dokumens)
      if (rekon === 0) return 'NOT-YET'
      if (rekon === total) return 'DONE'
      return 'PARTIAL'
    },
    getStatusClass(item) {
      const status = this.getStatus(item)
      if (status === 'DONE') return 'badge badge-success'
      if (status === 'PARTIAL') return 'badge badge-warning'
      return 'badge badge-secondary'
    },
    normalizeNominal(value) {
      const numericValue = Number(value) || 0

      // Karena nominal rupiah ditampilkan tanpa pecahan
      return Math.round(numericValue)
    },
  },
}
</script>

<style scoped>
.table-responsive {
  overflow: auto;
  max-height: 600px;
  position: relative;
}

.table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  font-size: 13px;
}

/* 1. Border lebih tipis dan lembut */
.table th,
.table td {
  border-top: 1px solid #e9ecef;
  border-left: 1px solid #e9ecef;
  padding: 8px 10px;
  background-color: #ffffff;
  white-space: nowrap;
}

/* 2. Header Sticky dengan border lebih tipis */
.header-lvl-1 th,
.header-lvl-2 th {
  position: sticky;
  background-color: #f8f9fa !important;
  z-index: 20;
  border-bottom: 1px solid #dee2e6; /* Border bawah header normal */
  border-top: 1px solid #dee2e6;
}

.header-lvl-1 th {
  top: 0;
}
.header-lvl-2 th {
  top: 37px;
}

/* 3. Sticky Columns dengan shadow yang sangat tipis/soft */
.sticky-col-1,
.sticky-col-2,
.sticky-col-uraian,
.sticky-col-last {
  position: sticky;
  z-index: 10;
  background-color: #ffffff !important;
}

/* Shadow yang lebih halus (tidak pekat) */
.sticky-col-uraian {
  left: 150px;
  min-width: 200px;
  /* Shadow tipis dan halus */
  box-shadow: 4px 0 6px -4px rgba(0, 0, 0, 0.2);
}

.sticky-col-last {
  right: 0;
  min-width: 100px;
  box-shadow: -4px 0 6px -4px rgba(0, 0, 0, 0.2);
}

.sticky-col-1 {
  left: 0;
  min-width: 50px;
}
.sticky-col-2 {
  left: 50px;
  min-width: 100px;
}

/* Memastikan Header Sticky menumpuk di atas shadow */
thead .sticky-col-1,
thead .sticky-col-2,
thead .sticky-col-uraian {
  z-index: 30;
}

/* Hover effect */
tr:hover td {
  background-color: #f8fafd !important; /* Warna hover lebih soft */
}

/* Shadow saat hover tetap halus */
tr:hover .sticky-col-uraian {
  box-shadow: 4px 0 6px -3px rgba(0, 0, 0, 0.3);
}
</style>
